/* ===== GIOVANNA'S GLOW — SHOPIFY APP JS ===== */

document.addEventListener('DOMContentLoaded', function () {

  /* ---------- CART DRAWER ---------- */
  var cartBtn     = document.getElementById('cartBtn');
  var cartDrawer  = document.getElementById('cartDrawer');
  var cartOverlay = document.getElementById('cartOverlay');
  var cartClose   = document.getElementById('cartClose');
  var cartCount   = document.getElementById('cartCount');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  if (cartBtn)     cartBtn.addEventListener('click', openCart);
  if (cartClose)   cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* ---------- MOBILE MENU ---------- */
  var menuBtn      = document.getElementById('menuBtn');
  var mobileMenu   = document.getElementById('mobileMenu');
  var mobileOverlay = document.getElementById('mobileOverlay');
  var mobileClose  = document.getElementById('mobileClose');

  function openMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('open');
    mobileOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'true');
  }
  function closeMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('open');
    mobileOverlay.classList.remove('open');
    document.body.style.overflow = '';
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
  }
  if (menuBtn)       menuBtn.addEventListener('click', openMenu);
  if (mobileClose)   mobileClose.addEventListener('click', closeMenu);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMenu);

  /* ---------- ADD TO CART (AJAX) ---------- */
  function updateCartCount(count) {
    var countEls = document.querySelectorAll('#cartCount, .cart-drawer-count');
    countEls.forEach(function (el) {
      el.textContent = el.classList.contains('cart-drawer-count') ? '(' + count + ')' : count;
    });
  }

  function addToCart(variantId, quantity, btn) {
    if (!variantId) return;
    var originalText = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: quantity || 1 })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) { throw new Error(err.description || 'Could not add to cart'); });
        }
        return res.json();
      })
      .then(function () {
        return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        btn.textContent = '✓ Added';
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1800);
        openCart();
        refreshCartDrawer();
      })
      .catch(function (err) {
        btn.textContent = originalText;
        btn.disabled = false;
        alert(err.message || 'Something went wrong. Please try again.');
      });
  }

  // Arch card Add to Bag buttons
  document.querySelectorAll('.arch-atc-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      addToCart(variantId, 1, btn);
    });
  });


  // Product page form
  var productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var variantId = document.getElementById('variantId').value;
      var btn = productForm.querySelector('.atc-submit');
      addToCart(variantId, 1, btn);
    });
  }

  /* ---------- FORMAT MONEY ---------- */
  function formatMoney(cents) {
    var fmt = (window.shopData && window.shopData.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
  }

  /* ---------- REFRESH CART DRAWER ---------- */
  function refreshCartDrawer() {
    var cartBody = document.getElementById('cartBody');
    if (!cartBody) return;
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        var footer = document.querySelector('.cart-drawer-footer');

        if (cart.item_count === 0) {
          cartBody.innerHTML = '<p class="cart-empty">Your bag is empty.</p>';
          if (footer) footer.style.display = 'none';
          return;
        }

        /* Render cart items */
        var html = '';
        cart.items.forEach(function (item) {
          var imgSrc = item.image ? item.image.replace(/(\.\w+)$/, '_120x120$1') : '';
          var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
            ? '<p class="cart-item-variant">' + item.variant_title + '</p>' : '';
          html += '<div class="cart-item">'
            + (imgSrc ? '<img src="' + imgSrc + '" alt="' + item.title + '" class="cart-item-img" />' : '')
            + '<div class="cart-item-details">'
            + '<p class="cart-item-name">' + item.product_title + '</p>'
            + variantLine
            + '<div class="cart-item-qty-row">'
            + '<div class="qty-control">'
            + '<button class="qty-btn" data-action="decrease" data-key="' + item.key + '">−</button>'
            + '<span class="qty-num">' + item.quantity + '</span>'
            + '<button class="qty-btn" data-action="increase" data-key="' + item.key + '">+</button>'
            + '</div>'
            + '<span class="cart-item-price">' + formatMoney(item.final_line_price) + '</span>'
            + '</div>'
            + '</div>'
            + '</div>';
        });
        cartBody.innerHTML = html;

        /* Update footer */
        if (footer) {
          footer.style.display = '';
          var subtotalEl = footer.querySelector('.cart-subtotal-price');
          if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
        }
      });
  }

  /* ---------- CART QTY CONTROLS ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.qty-btn');
    if (!btn) return;
    var key = btn.getAttribute('data-key');
    var action = btn.getAttribute('data-action');
    var qtyEl = btn.parentElement.querySelector('.qty-num');
    var currentQty = parseInt(qtyEl ? qtyEl.textContent : 1, 10);
    var newQty = action === 'increase' ? currentQty + 1 : Math.max(0, currentQty - 1);

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: newQty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if (qtyEl) qtyEl.textContent = newQty;
        if (newQty === 0) {
          var item = btn.closest('.cart-item, .cart-page-item');
          if (item) item.remove();
        }
        refreshCartDrawer();
      });
  });

  /* ---------- PRODUCT GALLERY THUMBNAILS ---------- */
  document.querySelectorAll('.thumb-btn').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = document.getElementById('mainProductImg');
      if (mainImg && thumb.getAttribute('data-src')) {
        mainImg.src = thumb.getAttribute('data-src');
        document.querySelectorAll('.thumb-btn').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      }
    });
  });

  /* ---------- PRODUCT VARIANT SELECTION ---------- */
  var swatches = document.querySelectorAll('.option-swatch');
  if (swatches.length) {
    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var index = swatch.getAttribute('data-option-index');
        swatch.closest('.option-values').querySelectorAll('.option-swatch').forEach(function (s) {
          s.classList.remove('active');
        });
        swatch.classList.add('active');
      });
    });
  }

  /* ---------- STICKY HEADER SHADOW ---------- */
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 10) {
        header.style.boxShadow = '0 2px 20px rgba(42,18,21,0.08)';
      } else {
        header.style.boxShadow = 'none';
      }
    });
  }

  /* ---------- LIVE CAD PRICE ---------- */
  var cadEls = document.querySelectorAll('.cad-equivalent');
  if (cadEls.length) {
    fetch('https://open.er-api.com/v6/latest/USD')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var rate = data.rates && data.rates.CAD;
        if (!rate) return;
        cadEls.forEach(function (el) {
          var usd = parseFloat(el.getAttribute('data-usd').replace(/,/g, ''));
          if (isNaN(usd)) return;
          el.textContent = '≈ $' + (usd * rate).toFixed(0) + ' CAD';
        });
      })
      .catch(function () {});
  }

  /* ---------- ESCAPE KEY ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeCart();
      closeMenu();
    }
  });

});
